<template>
  <el-row class="info-outer">
    <el-card :body-style="{padding: 0}" class="left">
      <div class="header">
        <el-avatar :size="80" :src="getFileUrl(org.logoPath)" alt="logo" shape="square"></el-avatar>
        <div>{{org.fullName}}</div>
      </div>
      <el-row v-for="column in columns" :key="column.value" :class="{current: column.value === currColumnValue}" class="info-column"
        @click="currColumnValue = column.value">
        <el-icon><component :is="column.icon" /></el-icon>
        <span>{{column.name}}</span>
      </el-row>
    </el-card>

    <div class="right">
      <base-info v-show="currColumnValue === 1" :org="org" />
      <org-info v-show="currColumnValue === 2" :id="id" :org="org" :currColumnValue="currColumnValue" />
      <role-info v-show="currColumnValue === 3" :id="id" :org="org" :currColumnValue="currColumnValue" />
      <project-list v-show="currColumnValue === 4" :id="id" :currColumnValue="currColumnValue" />
    </div>
  </el-row>
</template>

<script>
import {  } from '@/api/sys/org';
import { defineComponent } from 'vue'
import BaseInfo from './BaseInfo.vue';
import OrgInfo from './org/Index.vue';
import RoleInfo from './RoleInfo.vue';
import ProjectList from './project/List.vue';

import { getFileUrl } from '@/utils/common';
import { getEnterpriseById } from '@/api/enterprise';

export default defineComponent({
  components: { BaseInfo, OrgInfo, RoleInfo, ProjectList },
  data() {
    return {
      getFileUrl,
      id: null,
      org: {},
      currColumnValue: 1, // 当前栏目值
      columns: [
        { name: '企业信息', icon: 'document', value: 1 },
        { name: '组织信息', icon: 'histogram', value: 2 },
        { name: '角色信息', icon: 'avatar', value: 3 },
        { name: '项目信息', icon: 'school', value: 4 }
      ]
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (!this.id) {
      // this.back();
      this.$router.push('/sys/org/list')
      return;
    }
    this.getOrg();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getOrg() {
      getEnterpriseById(this.id).then(({data}) => {
        this.org = data.data;
        if (!this.org) {
          this.back();
        }
      })
    }
  }
})
</script>

<style lang="scss" scoped>
.info-outer {
  padding: 15px;
  justify-content: space-between;
  height: 100%;
  .left {
    width: 200px;
    text-align: center;
    .header {
      height: 145px;
      padding-top: 15px;
      background-color: #f5f5f5;
      .el-avatar {
        margin-bottom: 10px;
      }
    }
    .info-column {
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      cursor: pointer;
      color: #333;
      .el-icon {
        color: #ccc;
        margin-right: 15px;
      }
      &.current {
        color: blue;
        .el-icon {
          color: blue; 
        }   
      }
    }
  }
  .right {
    width: calc(100% - 220px);
  }
}
</style>